import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BlogPage = () => {
  const { t, i18n } = useTranslation();

  const articles = {
    fr: [
      {
        id: 'reconnexion-a-soi',
        image: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739113219/1739112803973_ta9cs1.jpg",
        date: "15 Mars 2024",
        category: "BIEN-ÊTRE",
        title: "L'Art de la Reconnexion à Soi",
        excerpt: "Découvrez comment nos retraites créent un espace sacré pour vous reconnecter à votre essence et retrouver votre équilibre intérieur."
      },
      {
        id: 'lacher-prise',
        image: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739113202/1739112803057_ndnvhp.jpg",
        date: "12 Mars 2024",
        category: "TRANSFORMATION",
        title: "Le Pouvoir du Lâcher-Prise",
        excerpt: "Explorez les techniques et pratiques qui vous permettront de vous libérer de vos blocages et d'embrasser votre plein potentiel."
      },
      {
        id: 'cultiver-confiance',
        image: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739113194/1736490672772_2_ffkp1w.jpg",
        date: "10 Mars 2024",
        category: "DÉVELOPPEMENT PERSONNEL",
        title: "Cultiver sa Confiance au Quotidien",
        excerpt: "Apprenez les rituels et habitudes qui vous aideront à renforcer votre confiance en vous et à rayonner dans tous les aspects de votre vie."
      }
    ],
    en: [
      {
        id: 'self-connection',
        image: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739113219/1739112803973_ta9cs1.jpg",
        date: "March 15, 2024",
        category: "WELLNESS",
        title: "The Art of Self-Connection",
        excerpt: "Discover how our retreats create a sacred space for you to reconnect with your essence and restore your inner balance."
      },
      {
        id: 'letting-go',
        image: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739113202/1739112803057_ndnvhp.jpg",
        date: "March 12, 2024",
        category: "TRANSFORMATION",
        title: "The Power of Letting Go",
        excerpt: "Explore the techniques and practices that will help you release your blockages and embrace your full potential."
      },
      {
        id: 'daily-confidence',
        image: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739113194/1736490672772_2_ffkp1w.jpg",
        date: "March 10, 2024",
        category: "PERSONAL DEVELOPMENT",
        title: "Cultivating Daily Confidence",
        excerpt: "Learn the rituals and habits that will help you strengthen your self-confidence and shine in all aspects of your life."
      }
    ]
  };

  const currentArticles = articles[i18n.language as keyof typeof articles] || articles.fr;

  return (
    <div className="pt-24">
      {/* Hero Section */}
      <div className="relative py-32 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(154,165,129,0.05)_0%,rgba(0,0,0,0)_70%)]" />
        <motion.div 
          className="text-center mb-20 relative z-10"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-5xl font-serif mb-6">
            {t('blog.title')} <span className="text-[#c9ab81] italic">{t('blog.subtitle')}</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            {t('blog.description')}
          </p>
        </motion.div>
      </div>

      {/* Articles Grid */}
      <div className="max-w-7xl mx-auto px-4 pb-32">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {currentArticles.map((article, index) => (
            <Link 
              key={article.id} 
              to={`/blog/${article.id}`}
              className="group block"
            >
              <motion.article
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                className="h-full"
              >
                <div className="overflow-hidden mb-8">
                  <motion.img 
                    src={article.image} 
                    alt={article.title} 
                    className="w-full h-[400px] object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="space-y-4">
                  <div className="flex items-center space-x-4 text-sm text-[#c9ab81]">
                    <span className="font-serif">{article.date}</span>
                    <span className="text-gray-600">•</span>
                    <span className="uppercase tracking-wider text-xs">{article.category}</span>
                  </div>
                  <h2 className="text-2xl font-serif group-hover:text-[#c9ab81] transition-colors duration-300">
                    {article.title}
                  </h2>
                  <p className="text-gray-400 leading-relaxed">{article.excerpt}</p>
                  <div className="pt-4">
                    <div className="inline-block relative">
                      <span className="text-[#c9ab81] font-serif">{t('blog.readMore')}</span>
                      <span className="absolute bottom-0 left-0 w-full h-px bg-[#c9ab81] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
                    </div>
                  </div>
                </div>
              </motion.article>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;